import React from 'react';

import { useIsPostAuthNav3MobileOrDesktop } from 'util/isPostAuthNav3Active';

import { ExpertAdvice } from 'pages/UniversalLanding/ExpertAdvice';
import { Header } from './Header';
import { DayOfBreadcrumbs } from './DayOfBreadcrumbs';
import { ShopByType } from './ShopByType';
import { SocialProof } from './SocialProof';
import { PAPER_EXPERT_ADVICES } from './paperExpertAdvices';
import { FeaturedDesign, FeaturedDesignProps } from './FeaturedDesign';
import { DayOfContainer } from './DayOf.style';

export type DayOfProps = FeaturedDesignProps;

export const DayOf: React.FC<DayOfProps> = featureDesignProps => {
  const isPostAuthNav3 = useIsPostAuthNav3MobileOrDesktop(featureDesignProps.userContext);

  return (
    <DayOfContainer isPostAuthNav3={isPostAuthNav3}>
      <Header />
      <DayOfBreadcrumbs />
      <ShopByType />
      <SocialProof />
      <FeaturedDesign {...featureDesignProps} />
      <ExpertAdvice advices={PAPER_EXPERT_ADVICES} />
    </DayOfContainer>
  );
};
